import script from "./PhotoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoSection.vue?vue&type=script&setup=true&lang=js"

import "./PhotoSection.vue?vue&type=style&index=0&id=256e1294&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-256e1294"]])

export default __exports__